import type { CollaborationTransport } from './protocol';

/**
 * The transport while the company's collaboration server is not connected: every call fails
 * with `unavailable`, which the interface shows as «Совместная работа пока недоступна».
 * What the server has to provide: `docs/server-needs.md`.
 */
export function createUnavailableTransport(): CollaborationTransport {
  const unavailable = (): Promise<never> =>
    Promise.reject(Object.assign(new Error('Collaboration is not connected yet.'), { code: 'unavailable' }));
  return {
    identity: unavailable, create: unavailable, inspectInvite: unavailable, join: unavailable,
    read: unavailable, submit: unavailable, receipt: unavailable, rotateInvite: unavailable,
    removeMember: unavailable, publish: unavailable, subscribe: unavailable,
    dispose: () => {},
  };
}
